import React from "react";
import ReactPlayer from "react-player/youtube";
import { MarkupText } from "./MarkupText";
export function ParagraphMainTextVideo(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "paragraph-container mt-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row items-stretch"
    }, !!props.mainText && /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-200 w-full md:w-[55%] py-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: " flex flex-col container-page gap-6"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "m-0"
    }, props.mainText.title), !!props.mainText.text && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.mainText.text,
        classNames: {
            p: "text-gray-700"
        }
    })))), !!props.video && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-4 bg-green-800 w-full flex-1 md:w-[45%]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative pt-[56.25%]"
    }, /*#__PURE__*/ React.createElement(ReactPlayer, {
        className: "absolute top-0 left-0",
        width: "100%",
        height: "100%",
        controls: true,
        url: props.video.video
    })), /*#__PURE__*/ React.createElement("div", {
        className: "container-page text-white"
    }, !!props.video.description && /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.video.description
    })))));
}
